export const ClosePoPermissions = [
  'CloseOfflinePoOwned',
  'CloseOfflinePoCompany',
  'ClosePoOwned',
  'ClosePoCompany',
];

export const ApproveInvoicePermissions = ['CanApproveInvoices'];
export const CanSubmitInvoicesCompanyPermissions = ['CanSubmitInvoicesCompany'];
export const CanAccessInvoiceManager = ['CanAccessInvoiceManager'];
export const ViewReceiptsCompany = ['ViewReceiptsCompany'];
export const CompleteInvoicePermissions = ['CanCompleteInvoicesSelf', 'CanCompleteInvoicesCompany'];
export const CompleteInvoicesCompanyPermissions = ['CanCompleteInvoicesCompany'];
export const DeleteInvoicePermissions = ['DeleteInvoicesOwn', 'DeleteInvoicesCompany'];
export const UnDeleteInvoicePermissions = ['DeleteInvoicesOwn', 'DeleteInvoicesCompany'];
export const CancelPoPermissions = ['CancelPOSelf', 'CancelPOCompany'];
export const ThreeWayMatchingPermissions = ['ThreeWayMatching'];
export const CompleteReceiptPermissions = ['CompleteReceiptsOwn', 'CompleteReceiptsCompany'];
export const DeleteReceiptPermissions = ['DeleteReceiptsOwn', 'DeleteReceiptsCompany'];
export const CreatePoPermission = ['IsPOReqToCreateInvoice'];
export const CreateInvoicePermission = ['CanRecieveInvoicesCompany', 'CanReceiveInvoices'];
export const CanManageOfflineSuppliers = ['CanManageOfflineSuppliers'];
export const BlindReceivePermissions = ['BlindReceive'];
export const IsManagerPermissions = ['IsManager'];
export const CanAccessReceipts = ['ReceivePoOwned', 'ReceivePoCompany'];
export const CanAccessReceiptsModule = ['CanAccessReceiving'];
export const CanCreateOfflinePo = ['CanCreateOfflinePo'];
export const RequireExistingPo = ['RequireExistingPo'];
export const ReceiptRequireDeliveryInfo: string[] = ['ReceiptRequireDeliveryInfo'];
export const ReceiptRequireReceiptDate: string[] = ['ReceiptRequireReceiptDate'];
export const InvoiceRequireReceiptDate: string[] = ['InvoiceRequireReceivedDate'];
export const CanReceiptUseNegativeQty: string[] = ['CanReceiptUseNegativeQty'];
export const UploadPdfOnly = ['UploadPdfOnly'];
export const IsInvcGLCodeNotesRequired: string[] = ['IsInvcGLCodeNotesRequired'];
export const InvoiceRequireExternalSupplierName: string[] = ['InvoiceRequireExternalSupplierName'];
export const InvoiceRequireApId: string[] = ['InvoiceRequireApId'];
export const CanCreditOveride: string[] = ['CanCreditOveride'];
export const ReceiptRequireAttachment = ['ReceiptRequireAttachment'];
export const SplitReceiptLineItem = ['CanSplitReceiptLineItems'];
export const AddLineItem: string[] = ['CanAppendReceiptLineItems'];
export const CanManageGLCodes: string[] = ['CanManageGLCodes'];
export const CanManageBudgets: string[] = ['CanManageBudgets'];
export const CanAdjustBudgetBalance: string[] = ['CanAdjustBudgetBalance'];
export const CanManageDepartments: string[] = ['CanManageDepartments'];
export const CanManageGLPeriods: string[] = ['CanManageGLPeriods'];
export const UsesNonCalendarYearPeriods: string[] = ['UsesNonCalendarYearPeriods'];
export const CanChangeInvoiceBudgetPeriod: string[] = ['CanChangeInvoiceBudgetPeriod'];
export const CanMpaPos: string[] = ['CanMpaPos'];
export const CanChangeSingleInvoiceBudgetPeriod: string[] = ['CanChangeSingleInvoiceBudgetPeriod'];
export const CanChangeMultipleInvoiceBudgetPeriods: string[] = [
  'CanChangeMultipleInvoiceBudgetPeriods',
];
export const CanUsesInitialBudgets: string[] = ['UsesInitialBudgets'];
export const CanOverrideBudgets: string[] = ['CanOverrideBudgets'];
export const CanEditCheckbookConfig: string[] = ['CanEditCheckbookConfig'];
export const IsRequireGlCodeFormats: string[] = ['RequireGlCodeFormats'];
export const CanManageGLCodeAttributes: string[] = ['CanManageGLCodeAttributes'];
export const UseClosePeriodPermissions: string[] = ['UseClosePeriod'];
export const CanClosePeriodPermissions: string[] = ['CanClosePeriod'];
export const CanImportSingleCompany = ['CanImport'];
export const CanImportMultipleCompanies = ['CanImportMultipleCompanies'];
export const IsSuperAdmin = ['IsSuperAdmin'];
export const IsSupplierUser = ['IsSupplier'];
export const exportInvoiceReadOnly = ['ExportInvoiceReadOnly'];
